export default __webpack_public_path__ + "static/media/portfolio-198.76736eb8.jpg";